import React from 'react';

const Arrow = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='28' height='9' viewBox='0 -2 13 10'>
      <g fill='none' fillRule='evenodd'>
        <g fill='var(--theme-primary, #810ea9)' fillRule='nonzero'>
          <g>
            <g>
              <g>
                <path
                  d='M3.112 7l4.632-4.537c.341-.335.341-.877 0-1.212-.342-.335-.896-.335-1.238 0l-5.25 5.143c-.341.335-.341.877 0 1.212l5.25 5.143c.342.335.896.335 1.238 0 .341-.335.341-.877 0-1.212L3.112 7z'
                  transform='translate(-46 -299) translate(17 264) translate(14 13) rotate(-90 23 8)'
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Arrow;
